// extracted by mini-css-extract-plugin
export default {"termsAndConditionsCheckbox":"TermsAndConditionsComponent_termsAndConditionsCheckbox__L4rf1","termsAndConditionsText":"TermsAndConditionsComponent_termsAndConditionsText__J1g3P"};